import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b8736c5")

_pushScopeId("data-v-5b8736c5")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("父类名称: ")
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("父类编码: ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_row, { class: "main-area" }, {
      default: _withId(() => [
        _createVNode("div", null, [
          _hoisted_1,
          _createVNode("strong", null, _toDisplayString(_ctx.parentCategory.name), 1)
        ]),
        _hoisted_2,
        _createVNode("div", null, [
          _hoisted_3,
          _createVNode("strong", null, _toDisplayString(_ctx.parentCategory.code), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_form, {
      ref: "formDom",
      "label-position": "right",
      "label-width": "80px",
      model: _ctx.categoryForm
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          hidden: "",
          required: "",
          label: "父类id"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.categoryForm.parentId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.categoryForm.parentId = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "code",
          rules: [
      { required: true, message: '请输入编码', trigger: 'blur' }
    ],
          label: "编码"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.categoryForm.code,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.categoryForm.code = $event))
            }, _createSlots({ _: 2 }, [
              (_ctx.parentCategory.id > 0)
                ? {
                    name: "prepend",
                    fn: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.parentCategory.code), 1)
                    ])
                  }
                : undefined
            ]), 1032, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "name",
          rules: [
      { required: true, message: '请输入名称', trigger: 'blur' }
    ],
          label: "名称"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.categoryForm.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.categoryForm.name = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { class: "flex-center" }, {
          default: _withId(() => [
            _createVNode(_component_el_button, {
              class: "margin-right-10",
              type: "primary",
              onClick: _ctx.onSave
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancel')))
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ], 64))
})